import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Container, Row, Col, Card, CardBody, Input, Label } from "reactstrap"
import Select from "react-select"
import { Link, useNavigate } from "react-router-dom"
import ReportImg from "../../../assets/images/ReportImg.jpg"
import "../../../assets/css/Finance/Style/ReportsFinance.css"
import zithasLogo from "../../../assets/images/zithasLogo.png"
import configure from "configure"

const Statement = () => {
  const [verticalActiveTab, setVerticalActiveTab] = useState("1")
  const [fixedSideTab, setFixedSideTab] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [isStatement, setIsStatement] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setFixedSideTab(window.scrollY > 68)
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [verticalActiveTab])

  const customerOptions = [
    {
      label: "Zithas Technologies Pvt. Ltd.",
      value: "Zithas Technologies Pvt. Ltd.",
    },
    { label: "Zithas Uk", value: "Zithas Uk" },
    { label: "Zithas India", value: "Zithas India" },
  ]

  document.title = "Statement | Zithas CRM"

  const handleGenerateStatement = e => {
    e.preventDefault()
    setIsStatement(true)
  }

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Statement" />
          <section className="bg-white" id="sectionReport">
            <form onSubmit={handleGenerateStatement}>

              <Row className="d-flex justify-content-center me-4 pt-4">
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="btn btn-red ms-md-2 btn-label"
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </button>
                </div>
              </Row>

              <Row>
                <Col lg={6} className="img-container">
                  <div className="d-flex justify-content-center align-items-start img-wrapper">
                    <div className="img-box text-end">
                      <img src={ReportImg} alt="Report" className="shadow-sm" />
                    </div>
                  </div>
                </Col>
                <Col lg={6}>
                  <Row className="pt-4 pe-4">
                    <Col md={3}>
                      <h4 className="text-dark mt-3">Statement</h4>
                    </Col>
                    <Col md={9}>
                      <div
                        className={`flex-column fixed-buttons pt-2 ${
                          fixedContent ? "d-flex" : "d-none"
                        }`}
                      >
                        <button
                          type="button"
                          onClick={() => navigate(-1)}
                          className="btn btn-red fix-btn btn-label pe-0"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          Cancel
                        </button>
                      </div>
                    </Col>
                  </Row>

                  <Row className="my-4">
                    <div className="row d-flex flex-column justify-content-start align-items-start">
                      <div className="mb-4 col-md-8">
                        <Label htmlFor="customerSelect">
                          Customer<span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="customerSelect"
                          placeholder="Select Customer"
                          className="basic-multi-select"
                          classNamePrefix="border-radius select"
                          options={customerOptions}
                        />
                      </div>
                      <div className="d-flex justify-content-start align-items-center gap-2 mb-4">
                        <div className="mb-3 col-md-3">
                          <Label htmlFor="fromDate">
                            From Date <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="fromDate"
                            placeholder="Enter Start Date"
                          />
                        </div>
                        <div className="mb-3 col-md-3">
                          <Label htmlFor="toDate">
                            To Date<span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="toDate"
                            placeholder="Enter End Date"
                          />
                        </div>
                      </div>
                      <div className="col-md-12 d-flex gap-3">
                        <Link
                          to={`${configure.appUrl}reports/finance/statement-formate`}
                          target="_blank"
                          type="submit"
                          className="btn btn-save text-white text-uppercase btn-label"
                        >
                          <i className="fas fa-plus me-2 icon-size label-icon"></i>
                          Generate Statement
                        </Link>
                        <button
                          type="button"
                          className="btn btn-save text-white text-uppercase btn-label"
                        >
                          <i className="fas fa-download me-2 icon-size label-icon"></i>
                          Download
                        </button>
                      </div>
                    </div>
                  </Row>
                  {isStatement === true ? (
                    <Row>
                      <Col md={12} className="p-0">
                        <Card>
                          <CardBody>
                            {/* <div
                          id="salaryslip-export"
                          className="container my-4 border border-dark border-3 px-2"
                        >
                          <div className="row border-bottom border-dark border-2 mb-3">
                            <div className="col-12 text-center  py-2">
                              <h1 className="text-primary">
                                <img
                                  src={zithasLogo}
                                  alt="Company Logo"
                                  height={55}
                                />
                              </h1>
                            </div>
                          </div>

                          <div className="row  mb-3">
                            <div className="col-12 text-center">
                              <strong>
                                FF-16, Kalpvrux Compex, Opp. GEB Substation,
                                Gotri, Vadodara, Gujarat 390021
                              </strong>
                            </div>
                            <input type="hidden" id="companyId" value="" />
                          </div>

                          <div className="row border-bottom border-dark border-2 mb-3 pb-2">
                            <div className="col-12 text-center">
                              <strong>Tel.:</strong> +91 7203882277
                              &nbsp;&nbsp;&nbsp;
                              <strong>E-mail :</strong> hr@zithas.com
                              &nbsp;&nbsp;&nbsp;
                              <strong>Website :</strong> www.zithas.com
                            </div>
                          </div>

                          <div className="row border-bottom border-dark border-2 mb-3">
                            <div className="col-12 text-center pb-2">
                              Pay Slip for the Period of{" "}
                              <strong>August - 2024</strong>
                            </div>
                          </div>

                          <div className="row border-bottom border-dark border-2 mb-0">
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-6 text-end">
                                  <label>Employee Id</label>
                                  <br />
                                  <label>Department</label>
                                  <br />
                                  <label>Date Of Joining</label>
                                  <br />
                                  <label>Days Worked</label>
                                  <br />
                                  <label>Bank Acct/Cheque No</label>
                                  <br />
                                </div>
                                <div className="col-6">
                                  <label>: ZI-01</label>
                                  <br />
                                  <label>: Develpment</label>
                                  <br />
                                  <label>: 29/05/2024</label>
                                  <br />
                                  <label>: 0</label>
                                  <br />
                                  <label>: </label>
                                  <br />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-6 text-end">
                                  <label>Name</label>
                                  <br />
                                  <label>Designation</label>
                                  <br />
                                  <label>Leaves</label>
                                </div>
                                <div className="col-6">
                                  <label>
                                    <strong>: Rahul Ovhal</strong>
                                  </label>
                                  <br />
                                  <label>: React Developer</label>

                                  <br />
                                  <label>: 0</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row border-bottom border-dark border-2 mb-0">
                            <div className="col-md-6 border-end border-dark border-2 py-0">
                              <div className="row">
                                <div className="col-6 py-2">
                                  <strong>Earnings</strong>
                                </div>
                                <div className="col-6 py-2 text-center">
                                  <strong>Amount</strong>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 ">
                              <div className="row">
                                <div className="col-6 py-2 ">
                                  <strong>Deductions</strong>
                                </div>
                                <div className="col-6 py-2 text-center">
                                  <strong>Amount</strong>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row border-bottom mb-0">
                            <div className="col-md-6 border-end border-dark border-2">
                              <div className="row">
                                <div className="col-6 py-2">
                                  <label>Basic Pay</label>
                                  <br />
                                  <label>Dearness Allowance</label>
                                  <br />
                                  <label>Medical Allowance</label>
                                  <br />
                                  <label>House Rent Allowance</label>
                                  <br />
                                  <label>Conveyance Allowance</label>
                                </div>
                                <div className="col-6 text-center py-2">
                                  <label>₹ 0.</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-6 py-2">
                                  <label>Employee State Insurance</label>
                                  <br />
                                  <label>Provident Fund</label>
                                  <br />
                                  <label>Professional Tax</label>
                                  <br />
                                  <label>Other Deduction</label>
                                  <br />
                                  <label>Punctual Deduction</label>
                                </div>
                                <div className="col-6 text-center py-2">
                                  <label>₹ 0.00</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                  <br />
                                  <label>₹ 0.00</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row border-top border-dark border-2">
                            <div className="col-md-6 border-end border-dark py-2">
                              <strong>Total Earnings</strong>
                            </div>
                            <div className="col-md-6 text-end py-2 pe-3">
                              <strong>₹ 0.00</strong>
                            </div>
                          </div>

                          <div className="row border-top border-dark border-2">
                            <div className="col-md-6 border-end border-dark py-2">
                              <strong>Total Deductions</strong>
                            </div>
                            <div className="col-md-6 text-end py-2 pe-3">
                              <strong>₹ 0.00</strong>
                            </div>
                          </div>

                          <div className="row border-top border-dark border-2 ">
                            <div className="col-md-6 border-end border-dark py-2">
                              <strong>Net Pay (Rounded)</strong>
                            </div>
                            <div className="col-md-6 text-end py-2 pe-3">
                              <strong>₹ 0.00</strong>
                            </div>
                          </div>

                          <div className="row border-bottom border-dark border-2 ">
                            <div className="col-md-6 small-section border-end border-dark py-2">
                              <strong>Employer's Signature :</strong>
                            </div>
                            <div className="col-md-6 small-section py-2">
                              <strong>Employee's Signature :</strong>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 text-center p-3">
                              <strong>
                                THIS IS A COMPUTER GENERATED SLIP, HENCE
                                SIGNATURE IS NOT REQUIRED
                              </strong>
                            </div>
                          </div>
                        </div> */}
                            <div className="statement-wrapper">
                              <div
                                className="statement-container"
                                id="pdfmaker"
                              >
                                <div className="display-flex">
                                  <div className="logo-container">
                                    <img src={zithasLogo} alt="Company Logo" />
                                  </div>
                                  <div className="address-right">
                                    Zithas Technologies Pvt. Ltd. FF-16 Kalpvrux
                                    Complex, Opp. GEB Substation, Gotri Road
                                    Vadodara Gujarat 390021 India GSTIN
                                    24AAKCG1425E1Z1
                                  </div>
                                </div>
                                <div className="row">
                                  <hr className="col-md-4" />
                                  <p className="col-md-4 text-center">
                                    STATEMENT
                                  </p>
                                  <hr className="col-md-4" />
                                </div>
                                <div className="row">
                                  <p className="col-md-6">
                                    <b>Customer Name :</b>{" "}
                                    <span id="custName">Zithas Tech.</span>
                                  </p>
                                  <p className="col-md-6">
                                    <b>Period :</b>{" "}
                                    <span id="period">
                                      01-06-2023 To 31-08-2024
                                    </span>
                                  </p>
                                </div>
                                <div className="items">
                                  <table className="item_table">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Date</th>
                                        <th>Inv No.</th>
                                        <th>Amount</th>
                                        <th>Received</th>
                                        <th>Remark</th>
                                      </tr>
                                    </thead>
                                    <tbody id="stat-data">
                                      <tr>
                                        <td>1</td>
                                        <td>23-07-2024</td>
                                        <td>PRF/2024-2025/0001</td>
                                        <td>₹ 708</td>
                                        <td>-</td>
                                        <td>-</td>
                                      </tr>
                                      <tr>
                                        <td>2</td>
                                        <td>24-07-2024</td>
                                        <td>PRF/2024-2025/0002</td>
                                        <td>$ 1180</td>
                                        <td>-</td>
                                        <td>-</td>
                                      </tr>
                                      <tr>
                                        <td>3</td>
                                        <td>25-07-2024</td>
                                        <td>PRF/2024-2025/0004</td>
                                        <td>$ 82.6</td>
                                        <td>-</td>
                                        <td>-</td>
                                      </tr>
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <td colSpan="3">
                                          <b>Total</b>
                                        </td>
                                        <td>
                                          <div className="currency-total">
                                            ₹ 708
                                            <br />
                                            $ 82.6
                                            <br />$ 1180
                                          </div>
                                        </td>
                                        <td>
                                          <div className="currency-total">
                                            ₹ 0<br />
                                            $ 0<br />$ 0
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colSpan="3">
                                          <b style={{ color: "red" }}>
                                            Balance
                                          </b>
                                        </td>
                                        <td colSpan="2">
                                          <div
                                            className="currency-total"
                                            style={{ color: "red" }}
                                          >
                                            ₹ 708
                                            <br />
                                            $ 82.6
                                            <br />$ 1180
                                          </div>
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col lg={12} className="p-0"></Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </form>
          </section>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Statement

//===============================================================================================

// import React, { useState, useEffect } from "react"
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
// import { Container, Row, Col, Card, CardBody, Input, Label } from "reactstrap"
// import Select from "react-select"
// import { useNavigate } from "react-router-dom"
// import ReportImg from "../../../assets/images/ReportImg.jpg"
// import "../../../assets/css/Finance/Style/ReportsFinance.css"
// import zithasLogo from "../../../assets/images/zithasLogo.png"

// const StatementPDF = ({ content }) => {
//   const [url, setUrl] = useState("")

//   useEffect(() => {
//     if (content) {
//       const blob = new Blob([content], { type: "text/html" })
//       const newUrl = URL.createObjectURL(blob)
//       setUrl(newUrl)
//     }
//   }, [content])

//   return url
// }

// const Statement = () => {
//   const [verticalActiveTab, setverticalActiveTab] = useState("1")
//   const [fixedSideTab, setFixedSideTab] = useState(false)
//   const [fixedContent, setFixedContent] = useState(false)
//   const [statementContent, setStatementContent] = useState("") // Statement content
//   const navigate = useNavigate()

//   useEffect(() => {
//     window.scrollTo(0, 0)
//     document.title = "Statement | Zithas Crm"
//   }, [verticalActiveTab])

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 68) {
//       setFixedSideTab(true)
//     } else {
//       setFixedSideTab(false)
//     }
//   })

//   const customer = [
//     {
//       label: "Zithas Technologies Pvt. Ltd.",
//       value: "Zithas Technologies Pvt. Ltd.",
//     },
//     { label: "Zithas Uk", value: "Zithas Uk" },
//     { label: "Zithas India", value: "Zithas India" },
//   ]

//   const toggleVertical = tab => {
//     if (verticalActiveTab !== tab) {
//       setverticalActiveTab(tab)
//     }
//   }

//   const generateStatement = () => {
//     // Generate the statement content
//     const content = `
//       <html>
//       <head>
//         <title>Statement</title>
//         <style>
//           /* Add your styles here */
//         </style>
//       </head>
//       <body>
//            <div className="container my-4 p-4 border rounded">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//             <div className="w-100">
//                 <img src="" alt="Company Logo" className="img-fluid" />
//             </div>
//             <div className="text-right">
//                 <p className="mb-0">Zithas Technologies Pvt. Ltd.</p>
//                 <p className="mb-0">FF-16 Kalpvrux Complex, Opp. GEB Substation, Gotri Road</p>
//                 <p className="mb-0">Vadodara Gujarat 390021 India</p>
//                 <p className="mb-0">GSTIN 24AAKCG1425E1Z1</p>
//             </div>
//         </div>

//         <div className="row mb-3">
//             <hr className="col-md-4">
//             <p className="col-md-4 text-center font-weight-bold mb-0" style="font-size: 18px;">STATEMENT</p>
//             <hr className="col-md-4">
//         </div>

//         <div className="row mb-3">
//             <div className="col-md-6">
//                 <p className="font-weight-bold mb-0">Customer Name:</p>
//                 <p id="custName">Zithas Tech.</p>
//             </div>
//             <div className="col-md-6">
//                 <p className="font-weight-bold mb-0">Period:</p>
//                 <p id="period">01-06-2023 To 31-08-2024</p>
//             </div>
//         </div>

//         <div className="table-responsive">
//             <table className="table item_table">
//                 <thead>
//                     <tr>
//                         <th>#</th>
//                         <th>Date</th>
//                         <th>Inv No.</th>
//                         <th>Amount</th>
//                         <th>Received</th>
//                         <th>Remark</th>
//                     </tr>
//                 </thead>
//                 <tbody id="stat-data">
//                     <tr>
//                         <td>1</td>
//                         <td>23-07-2024</td>
//                         <td>PRF/2024-2025/0001</td>
//                         <td>₹ 708</td>
//                         <td>-</td>
//                         <td>-</td>
//                     </tr>
//                     <tr>
//                         <td>2</td>
//                         <td>24-07-2024</td>
//                         <td>PRF/2024-2025/0002</td>
//                         <td>$ 1180</td>
//                         <td>-</td>
//                         <td>-</td>
//                     </tr>
//                     <tr>
//                         <td>3</td>
//                         <td>25-07-2024</td>
//                         <td>PRF/2024-2025/0004</td>
//                         <td>$ 82.6</td>
//                         <td>-</td>
//                         <td>-</td>
//                     </tr>
//                 </tbody>
//                 <tfoot>
//                     <tr>
//                         <td colSpan="2"></td>
//                         <td><b>Total</b></td>
//                         <td>
//                             <div className="currency-total">
//                                 <p>₹ 708</p>
//                             </div>
//                             <div className="currency-total">
//                                 <p>$ 82.6</p>
//                             </div>
//                             <div className="currency-total">
//                                 <p>$ 1180</p>
//                             </div>
//                         </td>
//                         <td>
//                             <div className="currency-total1">
//                                 <p>₹ 0</p>
//                             </div>
//                             <div className="currency-total1">
//                                 <p>$ 0</p>
//                             </div>
//                             <div className="currency-total1">
//                                 <p>$ 0</p>
//                             </div>
//                         </td>
//                     </tr>
//                     <tr>
//                         <td colSpan="2"></td>
//                         <td></td>
//                         <td><b className="text-danger">Balance</b></td>
//                         <td>
//                             <div className="currency-total2">
//                                 <p className="text-danger">₹ 708</p>
//                             </div>
//                             <div className="currency-total2">
//                                 <p className="text-danger">$ 82.6</p>
//                             </div>
//                             <div className="currency-total2">
//                                 <p className="text-danger">$ 1180</p>
//                             </div>
//                         </td>
//                     </tr>
//                 </tfoot>
//             </table>
//         </div>
//     </div>
//       </body>
//       </html>
//     `
//     setStatementContent(content)

//     const url = URL.createObjectURL(new Blob([content], { type: "text/html" }))
//     window.open(url, "_blank")
//   }

//   return (
//     <React.Fragment>
//       <div className="page-content mb-4">
//         <Container fluid>
//           <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Statement"} />
//           <section className="bg-white" id="sectionReport">
//             <form>
//               <Row>
//                 <Col lg={6} className="img-container">
//                   <div className="d-flex justify-content-center align-items-end img-wrapper">
//                     <div className="img-box text-end">
//                       <img src={ReportImg} alt="oppImg" className="shadow-sm" />
//                     </div>
//                   </div>
//                 </Col>
//                 <Col lg={6}>
//                   <Row className="pt-4 pe-4">
//                     <Col md={3}>
//                       <div>
//                         <h4 className="text-dark mt-3">Statement</h4>
//                       </div>
//                     </Col>
//                     <Col md={9}>
//                       <div
//                         className={`flex-column fixed-buttons pt-2 ${
//                           fixedContent ? "d-flex" : "d-none"
//                         }`}
//                       >
//                         <button
//                           onClick={() => navigate(-1)}
//                           type="button"
//                           className="btn btn-red fix-btn btn-label pe-0"
//                         >
//                           <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                           <span>Cancel</span>
//                         </button>
//                       </div>
//                       <div className="d-flex justify-content-end">
//                         <div className="text-md-end">
//                           <button
//                             type="button"
//                             onClick={() => navigate(-1)}
//                             className="btn ms-md-2 btn-red btn-label"
//                           >
//                             <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                             CANCEL
//                           </button>
//                         </div>
//                       </div>
//                     </Col>
//                   </Row>
//                   <Row className="my-4">
//                     <div className="row d-flex flex-column justify-content-start align-items-start">
//                       <div className="mb-4 col-md-8">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Customer<span className="text-danger">*</span>
//                         </Label>
//                         <Select
//                           placeholder="Select Customer"
//                           className="basic-multi-select"
//                           classNamePrefix="border-radius select"
//                           options={customer}
//
//                         />
//                       </div>
//                       <div className="d-flex justify-content-start align-items-center gap-2 mb-4">
//                         <div className="mb-3 col-md-3">
//                           <Label htmlFor="formrow-firstname-Input">
//                             From Date <span className="text-danger">*</span>
//                           </Label>
//                           <Input
//                             type="date"
//                             className="form-control"
//                             id="formrow-firstname-Input"
//                           />
//                         </div>
//                         <div className="mb-3 col-md-3">
//                           <Label htmlFor="formrow-firstname-Input">
//                             To Date<span className="text-danger">*</span>
//                           </Label>
//                           <Input
//                             type="date"
//                             className="form-control"
//                             id="formrow-firstname-Input"
//                           />
//                         </div>
//                       </div>
//                       <div className="col-md-12 d-flex gap-3">
//                         <button
//                           onClick={generateStatement}
//                           type="button"
//                           className="btn text-white text-uppercase btn-save btn-label"
//                         >
//                           <i className="fas fa-plus me-2 icon-size label-icon"></i>
//                           Generate Statement
//                         </button>

//                         <button
//                           type="submit"
//                           className="btn text-white text-uppercase btn-save btn-label"
//                         >
//                           <i className="fas fa-download me-2 icon-size label-icon"></i>
//                           Download
//                         </button>
//                       </div>
//                     </div>
//                   </Row>
//                 </Col>
//               </Row>
//             </form>
//           </section>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default Statement
